// management-frontend/src/index.js

import ReactDOM from "react-dom/client";
import App from "./App";
import ConfirmationProvider from "./components/ConfirmationModal/ConfirmationProvider";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfirmationProvider>
    <App />
  </ConfirmationProvider>,
);
